import React from 'react';
import { Typography, Paper } from '@mui/material';
import Layout from '../components/layout/Layout';
import ParametersTable from '../components/settings/ParametersTable';

const Settings = () => {
    return (
        <Layout>
            <Typography variant="h4" sx={{ mb: 3 }}>
                Parameters Settings
            </Typography>
            <Paper sx={{ p: 2 }}>
                <ParametersTable />
            </Paper>
        </Layout>
    );
};

export default Settings; 